import { useState, useEffect } from 'react';
import { ChevronRight, Search, ChevronLeft, ChevronsLeft, ChevronsRight, Trash2, Pencil, MoreVertical } from 'lucide-react';
import { useCreateUserList, useGetUserList } from "../../hooks/useUserList"

const UserLists = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');
    const [userList, setUserList] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const { data: userListResponse, isSuccess: isUserListSuccess } = useGetUserList(`?page=${currentPage}&limit=${rowsPerPage}&search_key=${searchTerm}`)

    const handleAddClick = () => {
        // setModalMode('add');
        // setShowModal(true);
    };

    const handleEditClick = (listItem) => {
    }
    
    const handleDelete = (listItem) => {
    }

    const toggleDropdown = (id) => {
        setShowDropdown(showDropdown === id ? null : id);
    };

    useEffect(() => {
        if (isUserListSuccess) {
            setUserList(userListResponse?.data?.data?.result)
            let tp = Math.ceil((userListResponse?.data?.data?.totalCount) / rowsPerPage)
            setTotalPages(tp == 0 ? 1 : tp)
        }
    }, [userListResponse, isUserListSuccess])

    return (
        <div className="flex min-h-screen bg-gray-50">
            {/* Main Content */}
            <div className="flex-1 flex flex-col">
                {/* Breadcrumb */}
                <div className="bg-white border-b border-gray-200 px-8 py-4">
                    <div className="flex items-center space-x-2 text-sm text-gray-500">
                        <span>Dashboard</span>
                        <ChevronRight className="w-4 h-4" />
                        <span className="text-gray-900">User Lists</span>
                    </div>
                </div>
                {/* Page Content */}
                <div className="flex-1 px-1 py-4">
                    <div className="max-w-7xl">
                        {/* Header */}
                        <div className="flex items-center justify-between mb-6">
                            <div>
                                <h1 className="text-2xl font-bold text-gray-900 mb-2">User Lists</h1>
                                <p className="text-gray-600">Manage and create user segments for targeted messaging</p>
                            </div>
                            <button
                                className="bg-black hover:bg-gray-800 text-white px-4 py-2 rounded"
                                onClick={handleAddClick}>
                                Create New User List
                            </button>
                        </div>
                        {/* Search */}
                        <div className="mb-6">
                            <div className="relative max-w-md">
                                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                                <input
                                    type="text"
                                    placeholder="Search by list name"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                />
                            </div>
                        </div>
                        {/* Table */}
                        <div className="bg-white rounded-lg border border-gray-200">
                            <table className="w-full">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            S.No
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            List Name
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            List Type
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Total Users
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Description
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Action
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {userList?.map((user, index) => (
                                        <tr key={user?._id} className="hover:bg-gray-50">
                                            <td className="px-6 py-4">
                                                {index + 1}
                                            </td>
                                            <td className="px-6 py-4 text-sm text-gray-900">{user?.title}</td>
                                            <td className="px-6 py-4 text-sm font-medium text-gray-900">{`Custom`}</td>
                                            <td className="px-6 py-4 text-sm font-medium text-gray-900">{`0`}</td>
                                            <td className="px-6 py-4 text-sm font-medium text-gray-900">{`${user?.description}`}</td>
                                            <td className="px-4 py-3 text-right">
                                                <div className="relative inline-block">
                                                    <button
                                                        onClick={() => toggleDropdown(user?._id)}
                                                        className="p-1 hover:bg-gray-100 rounded-full">
                                                        <MoreVertical size={16} />
                                                    </button>
                                                    {showDropdown === user?._id && (
                                                        <div className="absolute right-0 mt-2 w-48 bg-white rounded shadow-lg border border-gray-200 z-999">
                                                            <div className="py-1">
                                                                <button
                                                                    onClick={() => handleEditClick(user)}
                                                                    className="flex px-4 py-2 text-sm w-full text-left hover:bg-gray-100">
                                                                    <Pencil className='w-4 h-4 mr-1 mt-1' /> Edit
                                                                </button>
                                                            </div>
                                                            <div className="py-1">
                                                                <button
                                                                    onClick={() => handleDelete(user)}
                                                                    className="flex px-4 py-2 text-sm w-full text-left hover:bg-gray-100">
                                                                    <Trash2 className='w-4 h-4 mr-1' />Delete
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* Pagination */}
                            <div className="flex justify-end m-4">
                                <div className="flex items-center">
                                    <div className="mr-4 flex justify-between">
                                        <span className="mt-1 mr-2 text-sm text-gray-500">Rows per page</span>
                                        <select
                                            className="w-[55px] border border-gray-300 rounded p-1 text-sm"
                                            value={rowsPerPage}
                                            onChange={(e) => { setCurrentPage(1); setRowsPerPage(Number(e.target.value)) }}>
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                    </div>
                                    <div className="flex items-center text-sm">
                                        <span className="mr-4">Page {currentPage} of {totalPages}</span>
                                        <div className="flex">
                                            <button
                                                className="p-1 border border-gray-300 rounded-l hover:bg-gray-100"
                                                onClick={() => setCurrentPage(1)}
                                                disabled={currentPage === 1}>
                                                <ChevronsLeft size={16} />
                                            </button>
                                            <button
                                                className="p-1 border-t border-b border-gray-300 hover:bg-gray-100"
                                                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                                disabled={currentPage === 1}>
                                                <ChevronLeft size={16} />
                                            </button>
                                            <button
                                                className="p-1 border-t border-b border-gray-300 hover:bg-gray-100"
                                                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                                disabled={currentPage === totalPages}>
                                                <ChevronRight size={16} />
                                            </button>
                                            <button
                                                className="p-1 border border-gray-300 rounded-r hover:bg-gray-100"
                                                onClick={() => setCurrentPage(totalPages)}
                                                disabled={currentPage === totalPages}>
                                                <ChevronsRight size={16} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default UserLists;